import Http from '../../common/services/Http';
import { ReplicateVehicleExpensePlafondsDto, VehicleExpensePlafondDto } from './models/VehicleExpensePlafondDto';

class VehicleExpensePlafondsService {
    public getByVehicle(vehicleId: string) {
        return Http.get<VehicleExpensePlafondDto[]>(`vehicleexpenseplafonds/vehicle/${vehicleId}`);
    }

    public getById(id: string) {
        return Http.get<VehicleExpensePlafondDto>(`vehicleexpenseplafonds/${id}`);
    }

    public create(model: VehicleExpensePlafondDto) {
        return Http.post<string>('vehicleexpenseplafonds', model);
    }

    public update(model: VehicleExpensePlafondDto) {
        return Http.put('vehicleexpenseplafonds', model);
    }

    /** Soft-delete: PUT porque o serviço Http não expõe DELETE. */
    public remove(id: string) {
        return Http.put(`vehicleexpenseplafonds/deactivate/${id}`, {});
    }

    /** Copia os plafonds deste ativo para os escolhidos, substituindo o que lá estiver. */
    public replicate(model: ReplicateVehicleExpensePlafondsDto) {
        return Http.post('vehicleexpenseplafonds/replicate', model);
    }
}

export default new VehicleExpensePlafondsService();
